import React from 'react';
import { PropertyChangeLog } from '@upstart/harmony/lib/legos/financingTypes';
import { isDefined } from '@upstart/harmony/lib/legos/utils/tsutils';
import {
  formatPropName,
  formatPropValue,
} from '@upstart/harmony/lib/offerAudit-utils';
import './PropertyChange.scss';

export interface PropertyChangeProps {
  propertyChange: PropertyChangeLog;
}

export const PropertyChange: React.FC<PropertyChangeProps> = ({
  propertyChange,
}) => {
  const isOldValueDefined = isDefined(propertyChange.oldValue);
  return (
    <div className="propChangeContainer">
      {isOldValueDefined && (
        <div>
          {formatPropName(propertyChange.name)} changed from{' '}
          <span className="oldValue">
            {formatPropValue(propertyChange.name, propertyChange.oldValue)}
          </span>{' '}
          to{' '}
          <span className="newValue">
            {formatPropValue(propertyChange.name, propertyChange.value)}
          </span>
        </div>
      )}
      {!isOldValueDefined && (
        <div>
          {formatPropName(propertyChange.name)} set to{' '}
          <span className="newValue">
            {formatPropValue(propertyChange.name, propertyChange.value)}
          </span>
        </div>
      )}
    </div>
  );
};
